import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
export class AppComponent {
    constructor(swUpdate) {
        this.swUpdate = swUpdate;
    }
    ngOnInit() {
        this.subscriptionAppNewVersion = this.swUpdate.available.subscribe((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            setTimeout(() => {
                this.swUpdate.activateUpdate().then(() => window.location.reload());
            }, 2000);
        }));
    }
    ngOnDestroy() {
        if (this.subscriptionAppNewVersion) {
            this.subscriptionAppNewVersion.unsubscribe();
        }
    }
}
